import React, { SVGProps } from 'react';

const CopiedIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="53" viewBox="0 0 42 53" fill="none" {...props}>
        <path
            d="M12.3667 8.04321H7.43333C6.12493 8.04321 4.87012 8.56297 3.94494 9.48815C3.01976 10.4133 2.5 11.6681 2.5 12.9765V42.5765C2.5 43.8849 3.01976 45.1398 3.94494 46.0649C4.87012 46.9901 6.12493 47.5099 7.43333 47.5099H14.8333M37.0333 25.3099V12.9765C37.0333 11.6681 36.5136 10.4133 35.5884 9.48815C34.6632 8.56297 33.4084 8.04321 32.1 8.04321H27.1667M22.2333 37.6432V35.1765C22.2333 34.5223 22.4932 33.8949 22.9558 33.4324C23.4184 32.9698 24.0458 32.7099 24.7 32.7099H27.1667M34.5667 32.7099H37.0333C37.6875 32.7099 38.3149 32.9698 38.7775 33.4324C39.2401 33.8949 39.5 34.5223 39.5 35.1765V37.6432M39.5 45.0432V47.5099C39.5 48.1641 39.2401 48.7915 38.7775 49.2541C38.3149 49.7167 37.6875 49.9765 37.0333 49.9765H34.5667M27.1667 49.9765H24.7C24.0458 49.9765 23.4184 49.7167 22.9558 49.2541C22.4932 48.7915 22.2333 48.1641 22.2333 47.5099V45.0432"
            stroke="white"
            strokeWidth="4.93333"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
        <path
            d="M12.3667 8.0432C12.3667 6.7348 12.8865 5.47998 13.8116 4.5548C14.7368 3.62962 15.9916 3.10986 17.3 3.10986H22.2334C23.5418 3.10986 24.7966 3.62962 25.7218 4.5548C26.6469 5.47998 27.1667 6.7348 27.1667 8.0432C27.1667 9.3516 26.6469 10.6064 25.7218 11.5316C24.7966 12.4568 23.5418 12.9765 22.2334 12.9765H17.3C15.9916 12.9765 14.7368 12.4568 13.8116 11.5316C12.8865 10.6064 12.3667 9.3516 12.3667 8.0432Z"
            stroke="white"
            strokeWidth="4.93333"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </svg>
);

export default CopiedIcon;
